import App from '../App';
import { GUIDE_STEPS } from '../constants';

const asyncRoutes = {
  doesRequireServerApp: false,
  routes: {
    '': {
      onEnter({ routeTo }) {
        routeTo(GUIDE_STEPS[0].path);
      },
    },
    ':step': App,
  },
};

export default asyncRoutes;
